var map = {
	"./DiePraxis.jpg": 36,
	"./KursRaum.jpg": 100,
	"./Platzhalter.png": 101,
	"./PortraitOfUs.jpg": 41,
	"./PortraitOfUs.svg": 40,
	"./bewegung/Gymnastik.jpg": 38,
	"./bewegung/Yoga.jpg": 102,
	"./feldenkrais/Feldenkrais.jpg": 39,
	"./logoTop.png": 35,
	"./logoWithText.png": 103,
	"./massagen/Heilmassage.jpeg": 104,
	"./massagen/Lymphdrainage.jpeg": 105,
	"./massagen/Triggerpunktmassage.jpeg": 106,
	"./massagen/klassischeMassage.jpg": 107,
	"./massagen/massage-thumbnail.jpg": 37,
	"./team/barbara-rissi-hansbauer.jpg": 55,
	"./team/brigitta-parnigoni.jpg": 56,
	"./team/georg-hansbauer.jpg": 57,
	"./team/michael-ramoser.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;